import { useSwitchBreakpointFn } from 'presentation/hooks/useSwitchBreakpoint'

/**
 * @deprecated Use `useSwitchBreakpoint` or `useSwitchBreakpointFn` instead
 */
export const useMobFirstBreakpointValue = () => ({
  mfv: useSwitchBreakpointFn().sbp,
})
